export const phrases = {
  heading_settings_sort: "Triedenie zoznamu zamestnancov",
  body_settings_sort: "Zoraďte zoznam zamestnancov podľa mena alebo priezviska.",
  since_o_clock: "Od {time} hodiny",
  old_data_warning_my_area: "Nepodarilo sa nám načítať žiadne nové informácie. Uistite sa, že ste pripojení na internet.",
  no_data_warning_my_area: "Uistite sa, že ste pripojení na internet a skúste to znova.",
  no_data_available_my_area: "Nie je možné načítať žiadne údaje",
  last_update_data: "Posledná aktualizácia",
  something_went_wrong_absences: "Niečo sa pokazilo. Skúste to prosím neskôr.",
  something_went_wrong_with_the_pin_entry: "Niečo sa pokazilo pri zadávaní kódu PIN...",
  pin_must_be_four_digits: "PIN musí pozostávať presne zo štyroch číslic.",
  pins_do_not_match: "Zadané kódy PIN sa nezhodujú.",
  pin_is_not_numerical: "PIN môže pozostávať len z číslic.",
  /** Phrasen für Task.getTechnicalNameFinish
   * -> müssen vermutlich irgendwann nochmal bearbeitet werden
   * z.B. 'Projekt beenden' macht eventuell keinen Sinn, wenn man das Projekt nicht beendet,
   * sondern nur die Arbeitszeit, die man auf dieses Projekt stempelt ?
   */
  finish_work_time: "Vytlačiť pečiatku",
  finish_break: "Koniec prestávky",
  finish_loading_time: "Čas načítania na konci",
  finish_driving_time: "Čas ukončenia jazdy",
  finish_business_trip: "Ukončenie služobnej cesty",
  finish_project_as_task: "Dokončenie projektu",
  finish_special_one: "Koniec špeciálnej1",
  finish_special_two: "Koniec špeciálu2",
  you_clockout: "Vypichneš sa",
  sentence_work_time: "Pracujete. | Práve teraz pracujete.",
  sentence_break: "Dávate si prestávku. | Beriete si prestávku.",
  sentence_loading_time: "Práve zaznamenávate čas načítania. Hauruck! | Momentálne zaznamenávate čas načítania. Blbec!",
  sentence_business_trip: "Prihlásená služba. Bavte sa!",
  sentence_driving_time: "Rezervujete si čas jazdy. Pripútajte sa a vyrazte! | Rezervujete si čas jazdy. Pripútajte sa a choďte!",
  sentence_special_one: "Objednávate si Špeciál 1. | Rezervujete špeciálnu 1.",
  sentence_special_two: "Objednávate si Špeciál 2. | Rezervujete špeciálnu 2.",
  sentence_custom_time: "Vykonávate rezerváciu | Vykonávate rezerváciu",
  you_are_booked_in_activity: "Pečiatkujete {activity}! | Pečiatkujete {activity}!",
  substitute_warning: "{ days } V prípade niekoľkodňovej alebo dlhšej neprítomnosti musí byť vymenovaný zástupca.",
  substituted_by: "Zastúpená",
  name_clocked_in: "{name} vyrazené",
  /************************************/
  //Signature stuff:

  signature: "Podpis",
  please_sign: "Prosím, podpíšte",
  signature_with_date: "Podpis z {date}",
  signature_with_date_with_name: "Podpis {date} z {name}",
  signature_with_date_with_location: "Signature from {date} in {location}",
  signature_with_date_with_name_with_location: "Podpis {date} z {name} na {location}",
  signature_with_name: "Podpis na {name}",
  signature_with_name_with_location: "Podpis na {name} v {location}",
  signature_with_location: "Podpis na {location}",
  /*************************************/

  accept_terms_and_conditions: "Odoslaním formulára súhlasíte s našimi stránkami {agb} a {datenschutzerklaerung}.",
  what_is_your_name: "Ako sa voláte?",
  your_email: "Vaša e-mailová adresa",
  what_is_your_company_name: "Aký je názov vašej spoločnosti?",
  what_do_you_want_to_do_with_clockin: "Čo chcete robiť s clockinom?",
  almost_finished: "Takmer tam",
  test_clockin_for_amount_period: "Otestujte clockin {amountOfDaysTestPeriod} na niekoľko dní zadarmo!",
  code_needed_to_connect: "Použite svoj kód",
  you_have_no_company_code: "Nemáte kód? Kontaktujte osobu vo vašej spoločnosti.",
  connect_your_device: "Pripojte svoje zariadenie!",
  please_type_in_device_id: "Zadajte ID zariadenia, ktoré nájdete na našej webovej stránke v časti mobilné zariadenia.",
  new_at_clockin: "Ste nováčikom v systéme clockin?",
  pin_repeat: "Opakovanie kódu PIN",
  configure_your_pin: "Nastavenie 4-miestneho kódu PIN",
  configure_your_pin_text: "Na prístup do osobnej zóny na termináli tabletu potrebujete kód PIN.",
  congratulations: "Gratulujeme!",
  start_now: "Začnite hneď teraz",
  device_name_info: "Názov zariadenia mobilného zariadenia môžete zmeniť, aby ste mohli sledovať viacero zariadení. Príklad: \"Smartphone MaxMustermann\". Názov môžete zmeniť aj neskôr.",
  select_project: "Vybrať projekt",
  select_time: "Vybraný čas",
  create_new_account: "Vytvoriť nové konto",
  join_my_company: "Pridaj sa k mojej firme",
  join_clockin_with_qr: "Pripojte sa pomocou kódu QR",
  change_project: "Projekt zmeny",
  my_messages: "Moje novinky",
  my_documents: "Moje dokumenty",
  my_data_and_passwords: "Moje údaje a heslá",
  my_account_data: "Moje údaje",
  change_my_password: "Zmena hesla",
  forgot_password: "Nepoznám svoje heslo.",
  open_camera: "Otvorená kamera",
  scan_now: "Skenovať teraz",
  sync_now: "Synchronizovať teraz",
  clear_logs: "Prázdne protokoly",
  saveAndGoBack: "Uložiť a vrátiť",
  full_day: "Celý deň",
  activate_scanner: "Skener je aktivovaný",
  scanner_is_inactive: "Skener je neaktívny",
  change_project_by_scan_qr: "Naskenujte QR kód projektu, na ktorý chcete prejsť.",
  scan_device_by_qr: "Naskenujte kód QR zo zariadenia, ktoré chcete použiť.",
  no_access_to_camera_please_connect_device_manually: "K fotoaparátu sa bohužiaľ nepodarilo získať prístup, zadajte kód zariadenia manuálne.",
  no_access_to_camera_please_clockin_manually: "Bohužiaľ, nebol možný žiadny prístup k fotoaparátu, prosím, pečiatkujte ručne.",
  qr_code_login: "Registrácia kódu QR",
  scan_to_login: "Naskenujte kód QR a prihláste sa.",
  checklist_was_saved: "Kontrolný zoznam bol uložený",
  question_save_changes_short: "Uložiť zmeny?",
  question_save_changes: "Chcete zmeny uložiť?",
  question_delete_checklist_short: "Vymazať kontrolný zoznam?",
  question_delete_checklist: "Ste si istí, že chcete odstrániť kontrolný zoznam?",
  checklist_is_sending: "Kontrolný zoznam bude zaslaný",
  checklist_sent_successfully: "Kontrolný zoznam bol úspešne 🎉 odoslaný",
  checklist_could_not_be_sent: "Kontrolný zoznam sa nepodarilo odoslať, skúste to znova neskôr.",
  checklist_transmission_problems_in_the_past: "V minulosti sa vyskytli problémy s prenosom niektorých súborov.",
  checklist_send_with_potential_data_loss: "Chceli by ste skúsiť odoslať kontrolný zoznam bez týchto súborov?",
  documentation_is_sending: "Projektová dokumentácia sa zasiela",
  documentation_sent_successfully: "Projektová dokumentácia úspešne odoslaná 🎉",
  confirm_documentation_dismissal: "Naozaj chcete zlikvidovať dokumentáciu?",
  discard_unsaved_changes: "Chcete svoje zmeny zahodiť?",
  documentation_will_be_sent_when_online: "Dokumentácia vám bude zaslaná hneď, ako budete opäť online.",
  confirmation_is_sending: "Odoslanie potvrdenia projektu",
  ask_for_geo_permission: "Táto aplikácia potrebuje vašu polohu, " + "ale nemá na to povolenie.\n\n" + "Chcete otvoriť nastavenia?",
  all_projects: "Všetky projekty",
  half_day: "Pol dňa",
  start_end: "Podľa času",
  my_area: "Moja oblasť",
  my_area_video_teaser_clockin_explained_by_frederik: "hodiny vysvetlil Freddi",
  add_time: "Vytvoriť čas",
  show_times_in_confirmation: "Ukážte časy v potvrdení",
  change_time: "Čas zmeny",
  finish_project: "Kompletný projekt",
  finish_project_date: "Dokončenie vymenovania",
  unfinish_project: "Opätovné otvorenie projektu",
  unfinish_project_date: "Opätovné otvorenie stretnutia",
  absence_overview: "Správa absencií",
  edit_absence: "Upraviť absenciu",
  edited_absence: "Upravená neprítomnosť",
  created_absence: "Úspešne vytvorená žiadosť o dovolenku",
  creating_absence: "Vaša žiadosť o dovolenku je teraz vytvorená",
  error_creating_absence: "Chyba pri vytváraní žiadosti o neprítomnosť",
  create_absence: "Vytvoriť absenciu",
  deleted_absence: "Stiahnutie žiadosti o neprítomnosť",
  new_request: "Nová aplikácia",
  your_requests: "Vaše aplikácie",
  planned_days: "Plánované dni",
  planned_hours: "Plánované hodiny",
  used_days: "Počet použitých dní",
  used_hours: "Strávené hodiny",
  free_days: "Dni voľna",
  free_hours: "Prázdninové hodiny",
  open_days: "Dni otvorených dverí",
  open_hours: "Otváracie hodiny",
  withdraw_request: "Stiahnutie žiadosti",
  change_request: "Žiadosť o zmenu",
  request_was_approved: "Vaša žiadosť bola schválená",
  request_is_pending: "Vaša žiadosť ešte nebola schválená",
  request_was_rejected: "Vaša žiadosť bola zamietnutá",
  add_attachment: "Pridať prílohu",
  message_optional: "Správa (nepovinné)",
  filed_on: "Odoslané dňa",
  this_year: "Tento rok",
  search_sub_projects: "Na ktorom čiastkovom projekte by ste chceli pracovať?",
  error_occurred: "Vyskytla sa chyba, skúste to znova neskôr.",
  re_record: "Vymazať a znovu nahrať toto video?",
  delete_video: "Vymazať nahrávku?",
  no_results_found: "Nenašli sa žiadne výsledky",
  record_again: "Znova",
  request_valid_email: "Zadajte platnú e-mailovú adresu.",
  request_valid_company_name: "Zadajte platný názov spoločnosti.",
  request_valid_first_name: "Zadajte platné meno.",
  request_valid_last_name: "Zadajte platné priezvisko.",
  total_duration_today: "Celkový čas dnes",
  show_daily_protocol: "Zobraziť denný záznam",
  change_profile_pic: "Zmena profilového obrázka",
  logout_account: "Odpojenie účtu",
  you_are_working: "Práve teraz pracujete!",
  you_are_taking_a_break: "Máte prestávku!",
  activity_edited: "Upravená činnosť",
  activity_edited_undo: "Spracovanie úspešne zrušené",
  activity_edited_missing_project: "Projekt stále chýba!",
  activity_deleted: "Vymazaná činnosť",
  activity_deleted_undo: "Obnovenie vymazanej činnosti",
  activity_created: "Vytvorená nová aktivita",
  activity_created_undo: "Novovytvorená aktivita stiahnutá",
  correct_working_hours: "Správny pracovný čas",
  your_changes_are_being_saved: "Vaše zmeny sú teraz uložené.",
  manage_working_hours: "Riadenie pracovného času",
  delete_activity: "Odstránenie činnosti",
  start_navigation: "Spustenie navigácie",
  no_valid_email: "Zadaná e-mailová adresa nie je platná.",
  delete_checklist: "Odstránenie kontrolného zoznamu",
  active_checklists: "Aktívne kontrolné zoznamy",
  scan_qr_code: "Naskenovanie kódu QR",
  switch_to_office_center: "Prepnutie do kancelárskeho centra",
  confirm_project_completion_short: "Kompletný projekt",
  confirm_project_date_completion_short: "Dokončenie vymenovania",
  project_completed: "Projekt dokončený!",
  project_date_completed: "Menovanie dokončené!",
  confirm_project_uncompletion_short: "Opätovné otvorenie projektu",
  confirm_project_date_uncompletion_short: "Opätovné otvorenie stretnutia",
  project_uncompleted: "Projekt aktivovaný",
  project_date_uncompleted: "Dátum aktivácie",
  choose_project: "Vybrať projekt",
  choose_sub_project: "Vyberte podprojekt",
  choose_site: "Vyberte miesto",
  active_projects: "Aktívne projekty",
  completed_term: "dokončené",
  completed_projects: "Ukončené projekty",
  end_of_work: "Príjemný večer",
  correct_time: "Správny čas",
  you_stamp_x: "Pečiatka",
  enter_pin: "Zadajte prosím PIN",
  wrong_pin: "Nesprávne zadanie kódu PIN",
  pin_change_required: "Boli ste vyzvaní na zmenu PIN kódu",
  enter_new_pin: "Zadajte nový kód PIN",
  approve_pin: "Potvrdenie kódu PIN",
  no_projects_scheduled: "Za {day} Neukladajú sa žiadne projekty.",
  you_clock_in_project: "Odteraz budete zaznamenávať pracovný čas projektu.",
  project_scan_error: "Tento kód nie je platný pre žiadny projekt.",
  show_more_days: "zobraziť viac dní",
  show_more_times: "Ukázať viac časov",
  only_show_today: "Zobraziť len dnes",
  todays_total_time: "Celkový čas dnes",
  everything_synced: "Vaše údaje sú aktuálne!",
  upload_in_progress: "Údaje sú nahrané...",
  who_are_you: "Kto si?",
  is_uploading_to_server: "Vaše zmeny sa prenášajú do kancelárskeho centra.",
  offline_and_data_is_stored_locally: "Vaše zmeny sa čoskoro prenesú do kancelárskeho centra. ",
  show_more: "zobraziť viac",
  activity_edited_wrong_date: "Zadali ste nesprávny dátum.",
  confirm_logout: "Naozaj sa chcete odhlásiť?",
  confirm_clockout: "Ste si istí, že chcete dnes odísť?",
  gps_is_active: "Údaje GPS sa prenášajú",
  location_tracking_is_active: "Povolenie sledovania GPS.",
  app_settings: "Nastavenia aplikácie",
  clock_reminder: "Pečiatka - Pripomienka",
  mon_to_fri: "Štandard: pondelok – piatok",
  logout: "Odpojenie účtu",
  refresh: "Aktualizácia",
  prompt_language_settings: "Tu nastavte jazyk aplikácie.",
  prompt_clock_reminder: "Pripomienka prostredníctvom push notifikácií, aby zodpovedala vašej každodennej práci.",
  register_company: "Registrácia spoločnosti",
  use_code: "Použite kód",
  our_customers: "Naši zákazníci",
  free_test_now: "Testujte teraz bezplatne",
  tier_attendance: "Zaznamenávam len pracovný čas a prestávky.",
  tier_documentation: "Chcem tiež zaúčtovať pracovné hodiny na projekty, ktoré riadim v systéme clockin.",
  your_tier: "Váš balík",
  all_clockin_functions: "Všetky funkcie clockin",
  checklists_formulars: "Kontrolné zoznamy a funkcie",
  projectfile_incl_chat: "Digitálne súbory projektu (vrátane chatu)",
  photo_sketch_note: "Funkcia fotografie, náčrtu a poznámky",
  digital_signature: "Digitálne podpisy",
  datev_connection: "Pripojenie DATEV",
  calendar_absences: "Správa kalendára a absencií",
  individual_design: "Individuálny vzhľad",
  attendance_time_tracking: "Stacionárne zaznamenávanie času prostredníctvom terminálu tabletu",
  mobile_time_tracking: "Mobilné zaznamenávanie času prostredníctvom aplikácie pre smartfóny",
  browser_time_tracking: "Nahrávanie času prehliadača na počítači pre domácu kanceláriu",
  help_use_code: "Zadajte kód, ktorý nájdete v centre kancelárie v časti mobilné zariadenia/zamestnanci.",
  wrong_code: "Nesprávny kód",
  wrong_code_text: "Kód nie je platný. Skúste to prosím znova s platným kódom",
  wrong_code_text_short: "Kód je neplatný",
  clockin_logo: 'Clockin Logo',
  invalid_qr_code: "Neplatný QR kód",
  invalid_qr_code_text: "Naskenovaný QR kód nie je platný. Naskenujte platný kód hodinových záznamov.",
  code_already_connected: "Pomocou tohto kódu môžete pripojiť svoje zariadenie. Ale už ste pripojení.",
  wrong_credentials: "Nesprávne prístupové údaje",
  wrong_credentials_text: "Zadanú kombináciu e-mailu a hesla sa nepodarilo nájsť. Skontrolujte, prosím, svoje zadanie a skúste to znova.",
  new_pin: "Zadajte nový kód PIN",
  choose_next_action: "Vyberte si ďalšiu akciu",
  name_of_software_package: "Názov softvérového balíka",
  select_teamleader: "Kto pečiatkuje za tím?",
  select_teamleader_description: "Ak chcete pokračovať v pečiatkovaní, vyberte osobu, ktorá teraz prevezme stroj.",
  clocked_in_on_this_device: "Vyrazené na tejto jednotke",
  not_clocked_in_on_this_device: "Na tejto jednotke nie je vyrazené",
  select_new_teamleader: "Kto by mal teraz pečiatkovať za tím?",
  switch_teamleader: "Odovzdanie jednotky",
  just_me: "Práve odbíjanie hodín",
  select_the_new_teamleader: "Určenie nového vedúceho tímu",
  back_to_selection: "späť na výber",
  manage_team: "Riadenie tímu",
  total_time_team: "Celkový čas tímu",
  count_members_clocked_in: "{clockedin}/{members} Členovia tímu s pečiatkou",
  whole_team: "Celý tím",
  teammembers_still_clockedin: "Môžete si vybrať, či chcete odpracovať hodiny len vy, alebo všetci v tíme?",
  clockout_all: "Vymažte všetky",
  select_employee: "Najprv vyberte používateľa",
  something_went_wrong: "Niečo sa pokazilo, skúste to prosím neskôr.",
  new_pin_successfully_changed: "Úspešná zmena kódu PIN",
  enter_pin_before_clockin_prompt: "Najprv po jednom zadajte svoj PIN kód, aby ste sa mohli prihlásiť.",
  enter_pin_before_clockout_prompt: "Najskôr po jednom zadajte svoj PIN kód, aby ste sa mohli odhlásiť.",
  delete_activity_alert_title: "Odstránenie činnosti",
  delete_activity_alert_msg: "Ste si istí, že chcete aktivitu odstrániť?",
  delete_absence_message: "Ste si istí, že chcete stiahnuť žiadosť?",
  delete_absence_title: "Stiahnutie žiadosti",
  are_you_sure: "Ste si istý?",
  request_password: "Vyžiadanie nového hesla",
  password_requested: "Na vašu e-mailovú adresu bolo odoslané prepojenie na nové heslo.",
  no_email_retrieved: "Nedostali ste e-mail? Skontrolujte priečinok s nevyžiadanou poštou alebo to skúste znova.",
  name_of_customer: "Názov zákazníka",
  missing_permissions_homepage_text: "Nemáte oprávnenie meniť svoju aktivitu na tomto počítači. Pre získanie prístupu sa obráťte na svojho správcu.",
  no_permission_warning_my_area: "Na prístup do tejto oblasti nemáte povolenie. Ak chcete získať prístup, obráťte sa na svojho správcu.",
  employee_clocked_in: "{name} zaregistrovaná!",
  employee_clocked_out: "{name} odhlásil sa!",
  no_employee_to_qr_code_warning: "Pre tento kód QR sa nepodarilo nájsť žiadneho zamestnanca.",
  no_employees_registered_heading: "Do tejto jednotky zatiaľ nebol pridelený žiadny zamestnanec.",
  no_employees_registered_body: "V centre kancelárie v nastaveniach mobilného zariadenia môžete priradiť zamestnancov, ktorí potom môžu na tomto zariadení zaznamenávať svoj čas.",
  no_employee_found: "Bohužiaľ, nikoho s týmto menom sa nepodarilo nájsť.",
  no_employee_assigned: "Žiadny pridelený zamestnanec",
  you_need_help: "Potrebujete pomoc?",
  here_you_can_get_help_to_register_employees_for_device: "Tu nájdete všetky informácie o tom, ako priradiť zamestnancov k jednotke.",
  show_time: "Vytvoriť čas",
  export_timesheet: "Export časového hárku",
  select_month: "Vyberte mesiac",
  internet_connection_required: "Na to je potrebné internetové pripojenie.",
  select_an_activity_to_clockin_your_team: "Vyberte aktivitu, ktorú chcete v tíme opečiatkovať.",
  confirm_uploading_sqlite_for_debugging: "Ste si istí, že chcete nahrať údaje do aplikácie pre podporu Clockin?",
  no_tasks_available: "Žiadne úlohy k dispozícii",
  click_to_add_tasks: "Kliknite na pridanie úloh",
  scan_nfc_tag: "Kartu priložte k čítačke.",
  link_nfc_tag: "Prepojiť značku NFC",
  select_employee_for_nfc_tag: "Vyberte zamestnanca, ktorého chcete prepojiť s touto značkou NFC:",
  nfc_tag_linked_successfully: "NFC tag úspešne s {name} Prepojené.",
  nfc_linking_failed: "Značku NFC sa nepodarilo prepojiť. Skúste to znova.",
  nfc_not_enabled: "Toto zariadenie nepodporuje NFC alebo je zakázané.",
  nfc_initialization_failed: "Bohužiaľ, niečo sa pokazilo. Skúste to znova.",
  nfc_scan_failed: "Bohužiaľ, niečo sa pokazilo. Skúste to znova.",
  nfc_no_tag_found: "Nenašla sa žiadna značka NFC.",
  nfc_tag_already_linked_to: "Táto značka NFC je už k dispozícii s {name} Prepojené.",
  nfc_scan_active: "Aktívne skenovanie NFC",
  nfc_linking_enabled: "Značky NFC je teraz možné prepojiť. Podržte značku NFC, aby ste ju teraz prepojili s čítačkou NFC.",
  nfc_all_employees_linked: "Všetci zamestnanci priradení k tomuto zariadeniu už boli prepojení.",
  no_employee_to_nfc_warning: "Pre túto značku NFC sa nepodarilo nájsť žiadneho zamestnanca.",
  select_employee_to_link_nfc: "S kým by mala byť značka NFC prepojená?",
  new_onboarding: {
    personal_app_manager: {
      heading: {
        welcome: "Vitajte v Clockin",
        clocking_time: "Časy na trati",
        push_notifications: "Nezabudni na nič"
      },
      text: {
        clocking_time: "Hodinovač je vaším východiskovým bodom pre každú aktivitu. Vy sa staráte o svoju prácu, aplikácia robí dokumentáciu.",
        push_notifications: "Teraz zapni notifikácie. Clockin vám pripomenie, ak zabudnete známku, a uistí sa, že všetko dôležité dostanete hneď."
      },
      button: {
        lets_go: "Začnite hneď teraz"
      }
    },
    my_area: {
      heading: {
        my_area: "Moja oblasť",
        absences: "Absencie a žiadosti",
        settings: "Osobné nastavenia"
      },
      text: {
        my_area: "Centrálne miesto, kde máte okamžitý prehľad o svojom pracovnom čase a nadčasoch. Odtiaľto môžete spravovať svoj pracovný čas, pristupovať k dennému záznamu, zadávať požiadavky a prezerať si svoje časy.",
        absences: "Spravujte žiadosti o dovolenku, dni práceneschopnosti a iné neprítomnosti. Majte vždy prehľad o stave svojich žiadostí a nové žiadosti môžete odosielať rýchlo a jednoducho niekoľkými kliknutiami.",
        settings: "Pošlite spoločnosti správu alebo zmeňte svoje osobné nastavenia a ak chcete zmeniť heslo, môžete to urobiť aj tu!"
      },
      button: {
        lets_go: "Začnite"
      }
    }
  },
  onboarding: {
    personal_app: {
      heading: {
        your_time_matters: "Pretože váš čas sa počíta",
        clock_in: "Pečiatka v",
        switch_task: "Zmena pečiatky",
        clock_out: "Vytlačiť pečiatku",
        thats_it: "To je všetko!"
      },
      text: {
        your_time_matters: "Pomocou funkcie clockin vám pomôžeme sústrediť sa na podstatné veci. Zaznamenávajte svoj pracovný čas jediným kliknutím.",
        clock_in: "Jedným kliknutím sa priamo prihlásite. Clockin automaticky ukladá vaše údaje a vy máte vždy všetko na očiach.",
        switch_task: "Máte ďalší projekt, prestávku alebo idete na ďalšie stretnutie? Jednoducho si prelepte pečiatku na novú činnosť. Zvyšok sa zaznamená automaticky.",
        clock_out: "A jedným kliknutím ste vyradení.",
        thats_it: "Urobili ste to a ste pripravení zaznamenať svoj pracovný čas. Ak potrebujete pomoc, stačí nás kontaktovať. S clockinom je všetko jednoduché - vrátane komunikácie s nami."
      },
      button: {
        your_time_matters: "Ukážte mi, ako sa to robí",
        thats_it: "Začnite hneď teraz"
      }
    },
    team_app: {
      heading: {
        your_time_matters: "Pretože váš čas sa počíta",
        clock_in: "Pečiatka v",
        clock_in_team: "Registračný tím",
        switch_task: "Zmena pečiatky",
        change_teamleader: "Odovzdanie jednotky",
        clock_out: "Vytlačiť pečiatku",
        thats_it: "To je všetko!"
      },
      text: {
        your_time_matters: "Pomocou funkcie clockin vám pomôžeme sústrediť sa na podstatné veci. Zaznamenávajte pracovný čas svojho tímu jediným kliknutím.",
        clock_in: "Vyberte osobu, ktorá sa prihlasuje za tím, a jedným kliknutím sa priamo prihlásite. clockin automaticky ukladá údaje a vy môžete mať o všetkom neustále prehľad.",
        clock_in_team: "Jednoducho priamo opečiatkujte svoj tím. Či už všetci naraz, alebo len jednotliví členovia.",
        switch_task: "Máte iný projekt, prestávku alebo cestujete na ďalšie stretnutie? Jednoducho opečiatkujte svoju novú činnosť. Zvyšok sa zaznamená automaticky.",
        change_teamleader: "Končíte v práci, musíte odísť alebo už nepracujete pre tím? Jednoducho odovzdajte zariadenie v aplikácii a všetko sa vráti do normálu.",
        clock_out: "Jedným kliknutím vy a váš tím odídete. Samozrejme, môžete kedykoľvek odhlásiť aj jednotlivých členov.",
        thats_it: "Urobili ste to a ste pripravení zaznamenať pracovný čas pre svoj tím. Ak potrebujete pomoc, stačí nás kontaktovať. S clockinom je všetko jednoduché - vrátane komunikácie s nami."
      },
      button: {
        your_time_matters: "Ukážte mi, ako sa to robí",
        thats_it: "Začnite hneď teraz"
      }
    },
    my_area: {
      heading: {
        welcome: "Vitajte vo vašej oblasti",
        my_area: "Moja oblasť",
        create_time: "Vytvoriť čas",
        change_time: "Správny čas",
        absences: "Absencie a žiadosti",
        settings: "Osobné nastavenia",
        thats_it: "To je všetko!"
      },
      text: {
        welcome: "Objavte ešte viac spôsobov, ako efektívne a jednoducho riadiť svoj pracovný čas. Pozrime sa na vašu oblasť.",
        my_area: "Centrálne miesto, kde máte okamžitý prehľad o svojom pracovnom čase a nadčasoch. Odtiaľto môžete spravovať svoj pracovný čas, pristupovať k dennému záznamu, zadávať požiadavky a prezerať si svoje časy.",
        create_time: "Zabudli ste zadať čas alebo chcete pridať čas neskôr? Žiadny problém! Pridávajte chýbajúce časy, zaznamenávajte prestávky a udržujte svoje konto pracovného času aktuálne.",
        change_time: "Chcete opraviť svoje časy? Žiadny problém! Pomocou funkcie clockin môžete ľahko opraviť a upraviť nesprávne časy.",
        absences: "Spravujte žiadosti o dovolenku, dni práceneschopnosti a iné neprítomnosti. Majte vždy prehľad o stave svojich žiadostí a nové žiadosti môžete odosielať rýchlo a jednoducho niekoľkými kliknutiami.",
        settings: "Pošlite spoločnosti správu alebo zmeňte svoje osobné nastavenia a ak chcete zmeniť heslo, môžete to urobiť aj tu!",
        thats_it: "Dokázali ste to! Teraz môžete bez námahy riadiť svoj čas, organizovať absencie a sústrediť sa na to, čo je dôležité: na svoju prácu. Veľa šťastia s vašim produktívnym časom!"
      },
      button: {
        welcome: "Ukážte mi, ako sa to robí",
        thats_it: "Začnite hneď teraz"
      }
    },
    clock: {
      clockin_now: "Uzamknite teraz",
      clock_your_first_time_now: "& nahrávať prvýkrát"
    }
  },
  surveys: {
    nps: {
      thanks_for_using_clockin: "Ďakujeme, že používate clockin!",
      question: "Aká je pravdepodobnosť, že odporučíte zariadenie clockin svojim priateľom alebo kolegom?",
      very_likely: "Veľmi pravdepodobné",
      very_unlikely: "Veľmi nepravdepodobné",
      help_us_improve: "Ako vám môžeme zlepšiť funkciu clockin?",
      what_do_you_agree_with: "S ktorými tvrdeniami súhlasíte?",
      choose_three_statements: "Vyberte až tri výroky.",
      hard_to_use: "Ťažko ovládateľný",
      lacking_features: "Príliš málo funkcií",
      does_not_help_me: "mi neuľahčuje pracovný deň",
      confusing: "mätúce",
      poorly_implemented: "Zle implementované funkcie",
      too_buggy: "prílišná náchylnosť na chyby",
      too_slow: "dlhé časy načítania",
      what_else: "Chcete nám ešte niečo povedať?",
      can_we_ask_you_a_few_questions: "Môžeme vám položiť niekoľko ďalších otázok?",
      how_happy_are_you_with_the_introduction_of_clockin: "Ako ste spokojní so zavedením funkcie clockin vo vašej spoločnosti?",
      how_much_do_you_enjoy_using_clockin: "Ako sa vám páči používanie aplikácie clockin?",
      how_much_easier_does_clockin_make_your_work: "Do akej miery vám odomykanie hodín uľahčuje každodennú prácu?",
      how_happy_are_you_with_the_following_aspects: "Ako ste spokojní s nasledujúcimi bodmi?",
      clarity_of_the_app: "Prehľadnosť aplikácie",
      simplicity_of_use: "Jednoduchosť ovládania",
      app_features: "Funkcie v aplikácii",
      feedback_received: "Vaša spätná väzba bola prijatá. Ďakujeme, že ste si našli čas.",
      thanks_for_taking_the_time: "Ďakujeme, že ste si našli čas.",
      what_can_we_do_to_improve: "Môžete nám povedať viac o svojich skúsenostiach, aby sme to nabudúce mohli urobiť ešte lepšie?",
      what_can_we_do_to_get_it_right: "Môžete nám povedať viac o svojich skúsenostiach, aby sme to nabudúce mohli urobiť správne?",
      comment_placeholder: "Vaša správa"
    }
  },
  travel_logs: {
    add: "Pridanie podrobností o ceste",
    edit: "Upraviť podrobnosti o ceste",
    saving: "Podrobnosti o ceste sú uložené...",
    saved_successfully: "Údaje o ceste úspešne uložené!",
    unable_to_save: "Bohužiaľ to nevyšlo 😢"
  },
  attach_file: "Pripojte súbor",
  image_to_text: {
    info: "Dbajte na to, aby bol text jasne rozpoznateľný a aby bol na obrázku viditeľný celý.",
    attach_image: "Priložte obrázok",
    processing: "Váš text sa bude čítať v.",
    processing_failed: "Bohužiaľ, import nefungoval 😢",
    no_text_found: "Nebolo možné rozpoznať žiadny text."
  },
  correction_enter_reason: "Uveďte dôvod opravy.",
  daily_notes: {
    add: "Napíšte poznámku",
    edit: "Upraviť poznámku",
    saving: "Poznámka je uložená...",
    saved_successfully: "Poznámka bola úspešne uložená!",
    unable_to_save: "Bohužiaľ to nevyšlo 😢",
    no_notes_yet: "Žiadna poznámka nebola vytvorená",
    create_note: "Vytvoriť stránku"
  },
  calendar_sync: {
    title: "Synchronizovať plán",
    description: "Synchronizujte svoj pracovný rozvrh s kalendárom a sledujte staré a nové stretnutia.",
    url: "Adresa vo formáte iCal",
    url_description: "Túto adresu môžete použiť na prístup k tomuto kalendáru z iných aplikácií.",
    note: "Nápoveda",
    note_description: "V niektorých kalendároch môže trvať až 24 hodín, kým sa v nich zobrazia nové termíny.",
    sync_now: "Synchronizácia kalendára",
    copied: "Skopírovaná url adresa kalendára."
  },
  registration: {
    skip_all: "Preskočiť všetko",
    already_signed_up: "Už mám konto",
    title_1: "Začnime! Ktoré časy by ste chceli zaznamenať pomocou clockin?",
    description_1: "Dovoľte nám, aby sme pre vás prispôsobili clockin",
    option_1_a: "Všeobecný pracovný čas (príchod, odchod a prestávka)",
    option_1_b: "Pracovný čas projektu",
    title_2: "Chcete to zdokumentovať?",
    description_2: "Aké požiadavky musia byť splnené?",
    option_2_a: "Fotografie",
    option_2_b: "Náčrty",
    option_2_c: "Funkcia poznámky",
    option_2_d: "Kontrolné zoznamy a formuláre",
    option_2_e: "Digitálne súbory projektu",
    title_3: "Čo by ste ešte chceli digitalizovať?",
    description_3: "Na stránke clockin je toho oveľa viac, čo môžete objaviť, možno si tam nájdete niečo pre seba.",
    option_3_a: "Dovolenka",
    option_3_b: "Choroby a absencie",
    option_3_c: "Digitálny osobný spis",
    option_3_d: "Analýza spoločnosti",
    option_3_e: "Plánovanie nasadenia",
    option_3_f: "Daňový poradca pre prenos údajov (DATEV)",
    title_4: "V akom odvetví pôsobí vaša spoločnosť?",
    description_4: "Chceme vás lepšie spoznať, aby sme mohli hodiny prispôsobiť vašim potrebám.",
    option_4_a: "služby",
    option_4_b: "Remeslo",
    option_4_c: "Zdravie a wellness",
    option_4_d: "Nákup, objednávanie a obchodovanie",
    option_4_e: "Hotel a stravovanie",
    option_4_f: "Automobily, doprava a stroje",
    option_4_g: "Ostatné priemyselné odvetvia",
    title_5: "Koľko zamestnancov je súčasťou vašej spoločnosti?",
    description_5: "Počet zamestnancov môžeme prispôsobiť veľkosti vašej spoločnosti.",
    title_6: "Super! Váš clockin je teraz nastavený",
    description_6: "Potrebujeme len vaše meno.",
    input_6_a: "Spoločnosť",
    input_6_b: "Krstné meno",
    input_6_c: "Priezvisko",
    input_6_d: "Telefónne číslo",
    title_7: "Ste pripravení vyraziť! Vyskúšajte clockin 14 dní zadarmo!",
    input_7_a: "Vaša e-mailová adresa",
    description_7: "Na akú e-mailovú adresu máme poslať vaše heslo?",
    input_7_b: "Tak som si uvedomil.",
    how_did_you_hear_about_clockin: "Ako ste sa prvýkrát dozvedeli o spoločnosti clockin?",
    recommendation_option_1: "Odporúčanie",
    recommendation_option_2: 'Facebook',
    recommendation_option_3: 'Instagram',
    recommendation_option_4: "Vyhľadávanie na internete",
    recommendation_option_5: 'LinkedIn',
    recommendation_option_6: "Porovnávacia platforma",
    recommendation_option_7: "Články v časopisoch a online",
    known_from: "Známe z",
    agb_1: "Odoslaním formulára akceptujete ",
    agb_2: 'AGB',
    agb_3: " a ",
    agb_4: "Zásady ochrany osobných údajov",
    start: "Spustenie testu",
    validation_failed: "Vyplňte všetky polia správne."
  },
  clocki: {
    listening_heading: "Počúvam ťa",
    listening_subtext: "ako vám môžem pomôcť?",
    hi_0: "Dobrý deň, ako vám môžem pomôcť?",
    hi_1: "Ako vám môžem pomôcť?",
    hi_2: "Dobrý deň, ako vám môžem pomôcť?",
    hi_3: "Moin moin, čo pre vás môžem urobiť?",
    hi_4: "Dobrý deň, čo pre vás môžem urobiť?",
    hi_5: "Dobrý deň, ako vám môžem pomôcť?",
    // hi_1: 'Hi {name}​, sag mir, wie kann ich dir helfen?',
    // hi_2: 'Hi {name}​, wie kann ich dir helfen?',
    // hi_3: 'Hi {name}​, was kann ich für dich tun?',
    // hi_4: 'Moin {name}​, was kann ich für dich tun?',
    // hi_5: 'Hallo {name}​, wie kann ich dir helfen?',
    // hi_6: 'Grüß dich {name}​, wobei kann ich dich unterstützen?',
    // hi_7: 'Guten Tag {name}​, womit kann ich dir heute helfen?',
    speech_recognition_unavailable: "Bohužiaľ sa zdá, že rozpoznávanie hlasu vo vašom zariadení nefunguje",
    microphone_permission_denied: "Žiaľ, nemám prístup k vášmu mikrofónu. Skontrolujte, prosím, oprávnenia v nastaveniach, aby som vás mohol počuť.",
    please_speak: "Teraz môžete hovoriť so spoločnosťou Clocki",
    create_activity: "Vytvorenie aktivity",
    modify_activity: "Zmena aktivity",
    delete_activity: "Odstránenie aktivity",
    create_daily_note: "Vytvorenie dennej poznámky",
    search_project: "Vyhľadanie projektu",
    note_copied: "Poznámka skopírovaná",
    create_absence_request: "Žiadosť o neprítomnosť",
    delete_absence: "Vymazať neprítomnosť",
    confirm_deletion: "Ste si istí, že váš {activity_label} Pečiatkovanie z {date} Hodiny by mali byť vymazané?",
    confirm_absence_deletion: "Ste si istí, že vaša žiadosť o {category} Z {startDate} kým {endDate} Chcete odstrániť?",
    task_before_modification: "Pred: {task}",
    starts_at_before_modification: "Čas začiatku pred: {startsAt}",
    ends_at_before_modification: "Čas ukončenia pred: {endsAt}",
    something_went_wrong: "Niečo sa pokazilo, skúste to prosím neskôr.",
    was_this_helpful: "Mohol by vám Clocki pomôcť?",
    actions: {
      CREATE_ABSENCE: {
        title: "Potvrdenie neprítomnosti"
      },
      CREATE_DAILY_NOTE: {
        title: "Vytvoriť poznámku teraz",
        daily_notes_disabled: "Funkcia poznámky je bohužiaľ deaktivovaná. Požiadajte svojho správcu, aby túto funkciu aktivoval v kancelárskom centre.",
        success: "Poznámka úspešne uložená do denného záznamu 🎉"
      },
      CREATE_PROJECT_NOTE: {
        title: "Vytvoriť dokumentáciu teraz",
        created_by_clocki: "Vytvorené pomocou aplikácie Clocki"
      },
      REDIRECT_TO_CORRECT_TIMES: {
        title: "Otvorte teraz \"Moje časy\""
      },
      REDIRECT_TO_MY_AREA: {
        title: "Otvorte teraz \"Moja oblasť\""
      },
      REDIRECT_TO_CHANGE_PASSWORD: {
        title: "Otvorte \"Zmeniť heslo\" teraz"
      },
      CHANGE_ACTIVITY: {
        WORKING_TIME: "Známka \"pracovný čas\" teraz",
        PAUSE: "Pečiatka \"Pauza\" teraz",
        DRIVING_TIME: "Známka \"čas na cestu\" teraz",
        LOGOUT: "Odomknite teraz"
      }
    }
  },
  review_prompt: {
    do_you_like_clockin: "Radi používate Clockin?"
  },
  translation_failed: "Bohužiaľ, preklad nefungoval 😕",
  video_transcript_not_available: "Prepis nie je k dispozícii",
  video_upload_succeeded: "Nahranie videa dokončené.",
  video_upload_failed: "Nahrávanie videa zlyhalo.",
  video_send_failed: "Video momentálne nebolo možné odvysielať. Skúsime to neskôr znova.",
  uploading_video: "Nahrávam video...",
  language_selection_header: "Vybraný jazyk",
  language_selection_message: "Vyberte si preferovaný jazyk",
  shifts: {
    my_shifts: "Moje smeny",
    free_shifts: "Voľné smeny",
    next_shift: "Tvoja ďalšia zmena",
    shift_not_found: "Nenašli sa žiadne vrstvy",
    show_shift_plan: "Pozrite si tento rozvrh zmien",
    no_shift_place: "Miesto nebolo špecifikované",
    no_shifts_assigned: "Momentálne nie si pridelený na žiadnu zmenu",
    free_shifts_unavailable: "Voľné smeny momentálne nie sú dostupné",
    filter_shift_plans: "Filtračné rozvrhy zmien",
    no_shift_plans_available: "Nie sú k dispozícii žiadne rozvrhy zmien",
    filter_locations: "Filtračné miesta",
    no_locations_available: "Nie sú k dispozícii žiadne miesta",
    no_plan_selected: "Nie je vybraný žiadny rozvrh zmien",
    no_shifts_for_plan: "Pre tento plán sa nenašli žiadne vrstvy",
    no_shifts_for_location: "Pre vybrané miesto neboli nájdené žiadne zmeny",
    unknown_shift_plan: "Neznámy rozvrh zmien",
    unknown_location: "Neznáma poloha",
    loading_more_shifts: "Načítaj viac vrstiev..."
  },
  clockin_reminder_title: "Už v práci? 🔔",
  clockin_reminder: "Nezabudnite sa prihlásiť.",
  clockout_reminder_title: "Už si na konci dňa? 🔔",
  clockout_reminder: "Nezabudnite sa odhlásiť.",
  choose_clockin_reminder_time: "Pripomienka na pripomenutie príchodu",
  choose_clockout_reminder_time: "Pripomienka na odchod z práce",
  choose_break_reminder_time: "Dĺžka pauzy",
  saved_successfully: "Úspešne zachránené 👍",
  clock_reminder_channel_name: "Pripomienky na známkach",
  clock_reminder_channel_description: "Pripomienky na prihlásenie sa a odhlásenie",
  break_reminder_title: "Stále si dávaš pauzu? ⏰",
  break_reminder: "Poznámka: Vaša prestávka stále beží.",
  // Video component translations
  video_not_supported: "Tvoje zariadenie nepodporuje video :/",
  video_loading_error: "Chyba pri načítavaní videa",
  video_retry: "Nabíjanie"
};